export const TRANSACTION_TYPES = {
    cash: "Наличный",
    card: "Транспортной картой (без льготных)",
    exempt: "Льготные транспортные карты",
  },
  COLORS = ["#01b8aa", "#fbc02d", "#fd625e", "#0975da", "#8e24aa", "#72a62e"];
